import { useReselector } from '@/utils/sharedHooks'

import { selectCurrentAnnualTaxYear } from '@/featuresV1/Admin/AnnualTaxDetails/annualTaxDetails.selector'
import { UserActionItem } from '../lib/userActionItems.slice'
import {
  UserActionItemTabPane,
  ACTION_ITEM_TYPE,
} from '../UserActionItemTabPane'

import { TypographyStyles } from '@/styles'
import { Badge, Card, CardColors, Link, Text } from '@/ui'

interface EoyActionItemsCardProps {
  incompleteEoyActionItems: UserActionItem[]
  isUrgent: boolean
}

export const EoyActionItemsCard = ({
  incompleteEoyActionItems,
  isUrgent,
}: EoyActionItemsCardProps) => {
  const currentTaxYear = useReselector(selectCurrentAnnualTaxYear)

  return (
    <Card className="min-h-[300px]" color={CardColors.LEVEL_0}>
      <div className="flex flex-col space-y-4">
        <div className="flex items-center">
          {isUrgent && (
            <Badge color="red" className="mr-2.5">
              Urgent
            </Badge>
          )}
          <Text variant={TypographyStyles.H2}>
            Finish Your {currentTaxYear} Books
          </Text>
        </div>

        <Text>
          Uploading the following allows Heard to finish your bookkeeping, which
          must be done before you can submit your Tax Checklist.{' '}
          <Link
            href="https://support.joinheard.com/hc/en-us/articles/19809547067543"
            newPage
            variant="secondary"
          >
            How do I find these documents?
          </Link>
        </Text>

        <UserActionItemTabPane
          groupOption={'date-asc-groupedby-categoryName'}
          tabPaneType={ACTION_ITEM_TYPE.ACTIVE}
          userActionItems={incompleteEoyActionItems}
          hideCalendar
        />
      </div>
    </Card>
  )
}
